module.exports = __webpack_public_path__ + "img/messenger.35a967e0.svg";